import React from 'react';
import Text, { TextSize, TextProps } from '../../../Text';
import { st, classes } from './Label.st.css';
import { FieldSetProps } from '../../FieldSet.types';
import Asterisk from '../Asterisk';
import InfoContentIcon from '../InfoContentIcon';

type LabelSize = Extract<TextSize, 'small' | 'tiny'>;

type Props = Pick<TextProps, 'aria-hidden' | 'ellipsis' | 'maxLines' | 'id'> &
  Pick<FieldSetProps, 'infoContent' | 'infoTooltipProps' | 'required'> & {
    dataHook: string;
    label: React.ReactNode;
    tagName?: 'label';
    labelSize: LabelSize;
    hasInlineElements?: boolean;
  };

const Label = ({
  labelSize,
  label,
  'aria-hidden': ariaHidden,
  hasInlineElements,
  required,
  infoContent,
  infoTooltipProps,
  ...rest
}: Props) => {
  const weight = labelSize === 'tiny' ? 'normal' : undefined;
  const hasSuffix = required || infoContent;

  return (
    <Text
      aria-hidden={ariaHidden}
      className={st(classes.root, {
        hasInlineElements,
        labelSize,
      })}
      size={labelSize}
      weight={weight}
      secondary
      style={{ display: 'block' }} // allows the label to middle vertically
      suffix={
        hasSuffix ? (
          <>
            {required && <Asterisk labelSize={labelSize} />}
            <InfoContentIcon
              required={required}
              infoContent={infoContent}
              infoTooltipProps={infoTooltipProps}
            />
          </>
        ) : undefined
      }
      {...rest}
    >
      {label}
    </Text>
  );
};

export default Label;
